/**
 * 下層ページ ja
 */
import ResizeObserver from 'resize-observer-polyfill';
import 'es6-promise/auto';
import 'picturefill';
import { assets_path, breakpoint, containerID } from '@/_modules/utils/variables';
import {gsap, ScrollToPlugin, Power2} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalTrigger from '@/_components/global-trigger.vue';
import GlobalFooter from '@/_components/global-footer.vue';
//import GlobalLinks from '@/_components/global-links.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import PcSideFeature from '@/_components/pc-side-feature.vue';
import RelatedLinks from '@/_components/related-links.vue';
import ModalBenefit from '@/_components/modal-benefit.vue';
//import ModalCookie from '@/_components/modal-cookie.vue';

//import ScrollPlugin from '@/_modules/scroll-plugin'
//Vue.use(ScrollPlugin);
import AnchorPlugin from '@/_modules/anchor-plugin'
Vue.use(AnchorPlugin);

import Share from '@/_modules/common/share';
import ParallaxImg from '@/_modules/common/parallax_img';
//import ScrollWatch from '@/_modules/utils/ScrollWatch';

export default class AppVue {
  /**
   * コンストラクタ
   */
  constructor(category) {
    // クラス名
    this.name = 'AppVue';
    this.init(category);
  }

  /**
   * 初期
   */
  init(category) {

    this.vue = new Vue({
      components: {
        Loading,
        GlobalHeader,
        GlobalTrigger,
        GlobalFooter,
        //GlobalLinks,
        GlobalNavi,
        PcSideFeature,
        RelatedLinks,
        ModalBenefit
        //ModalCookie
      },
      data() {
        return {
          assets_path: assets_path,
          category: category,
          urls: {},
          ispc: false,
          isStart: false,
          isScrollHide: true,
          videoSrc: [
            '',
            '',
            '',
            '',
            ''
          ],
          elView: [
            { el: null, rect: null, isShow: false },
            { el: null, rect: null, isShow: false },
            { el: null, rect: null, isShow: false },
            { el: null, rect: null, isShow: false },
            { el: null, rect: null, isShow: false }
          ],
          elShow: [],
          preWidth: 0,
          windowHeight: 0,
          renders: [],
          styleMv: '',
          mvSize: {
            pc: {
              h: 1278,
              w: 2414
            },
            sp: {
              h: 1898,
              w: 1500
            }
          },
          mvAdjust: {
            pc: {
              h: 80,
              w: 160
            },
            sp: {
              h: 0, //238,//global netwok
              w: 0
            }
          }
        }
      },
      el: containerID,
      store,
      computed: {
        setStyleMv: function() {
          return function() {
            return this.styleMv;
          }
        }
      },
      created() {
        this.$store.commit('setLang');
        this.$store.commit('setUA');
      },
      mounted() {
        this.urls = this.$store.getters.getUrls;

        document.getElementById('c-wrapper').style.visibility = 'visible';

        this.resize();

        // パララックス要素を設定
        document.querySelectorAll('.c-parallax').forEach((el, i) => {
          this.renders.push(new ParallaxImg(el, el.querySelector('.c-parallax__wrap')));
        });

        if (this.category === 'benefit') {
          if (this.$store.getters.getLang === 'ja') {
            this.videoSrc[0] = `${assets_path}video/benefit/01_ja.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/02_ja.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/03_ja.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/04_ja.mp4`;
          } else if (this.$store.getters.getLang === 'de') {
            this.videoSrc[0] = `${assets_path}video/benefit/de/01.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/de/02.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/de/03.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/de/04.mp4`;
          } else if (this.$store.getters.getLang === 'fr') {
            this.videoSrc[0] = `${assets_path}video/benefit/fr/01.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/fr/02.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/fr/03.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/fr/04.mp4`;
          } else if (this.$store.getters.getLang === 'es') {
            this.videoSrc[0] = `${assets_path}video/benefit/es/01.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/es/02.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/es/03.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/es/04.mp4`;
          } else if (this.$store.getters.getLang === 'it') {
            this.videoSrc[0] = `${assets_path}video/benefit/it/01.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/it/02.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/it/03.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/it/04.mp4`;
          } else if (this.$store.getters.getLang === 'zh-cmn-Hant') {
            this.videoSrc[0] = `${assets_path}video/benefit/tc/01.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/tc/02.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/tc/03.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/tc/04.mp4`;
          } else if (this.$store.getters.getLang === 'zh-cmn-Hans') {
            this.videoSrc[0] = `${assets_path}video/benefit/sc/01.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/sc/02.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/sc/03.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/sc/04.mp4`;
          } else {
            this.videoSrc[0] = `${assets_path}video/benefit/01_en.mp4`;
            this.videoSrc[1] = `${assets_path}video/benefit/02_en.mp4`;
            this.videoSrc[2] = `${assets_path}video/benefit/03_en.mp4`;
            this.videoSrc[3] = `${assets_path}video/benefit/04_en.mp4`;
          }
        } else {
          this.videoSrc[0] = `${assets_path}video/technology/01.mp4`;
          this.videoSrc[1] = `${assets_path}video/technology/02.mp4`;
          this.videoSrc[2] = `${assets_path}video/technology/03.mp4`;
          this.videoSrc[3] = `${assets_path}video/technology/04.mp4`;
          this.videoSrc[4] = `${assets_path}video/technology/05.mp4`;
        }

        // SNSシェアボタンを設定
        new Share(this.$refs['c-pageShare__sns']);

        this.$nextTick(this.start);
      },
      methods: {
        onResizeObserver(entries) {
          this.resize();
        },
        openModal(num) {
          this.$refs['ModalBenefit'].open(num);
        },
        start() {
          // OpeningMovieコンポーネントから実行している
          this.resize();
          this.scroll();
          this.$refs.GlobalHeader.start();
          this.$refs.GlobalTrigger.start();
          this.$refs.PcSide.start();
          this.startMv();

          document.body.style.overflow = 'auto';
        },
        startComp() {
          // オブザーバインスタンスを作成
          this.observer = new ResizeObserver(this.onResizeObserver);
          this.observer.observe(this.$el);
          //window.addEventListener('resize', this.resize);
          window.addEventListener('scroll', this.scroll);
          this.parallax();
        },
        startMv() {
          this.isStart = true;
          this.isScrollHide = false;

          let imgW, imgH;
          const winW = this.getBodyWidth();
          const winH = window.innerHeight;
          this.windowHeight = winH;

          let adjust = {};
          if (this.ispc) {
            imgW = this.mvSize.pc.w;
            imgH = this.mvSize.pc.h;

            if (this.isStart) {

              if (window.innerWidth > 1366) {
                adjust = this.mvAdjust.pc;
              } else {
                adjust = {
                  w: (this.mvAdjust.pc.w / 1366) * window.innerWidth,
                  h: this.mvAdjust.pc.h
                };
              }
            } else {
              adjust = {
                h: 0,
                w: 0
              };
            }
          } else {
            //adjust = this.mvAdjust.sp;
            adjust = {
              h: (this.mvAdjust.sp.h / 750) * window.innerWidth,
              w: 0
            };
            imgW = this.mvSize.sp.w;
            imgH = this.mvSize.sp.h;
          }

          const bgW = winW - adjust.w;
          const bgH = winH - adjust.h;
          const scale = Math.max(bgW / imgW, bgH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (bgW - frameW) / 2;
          const frameY = (bgH - frameH) / 2;

          //this.styleMv = `height:${winH}px; width:${winW}px`;
          this.styleMv = `height:${winH}px; width:100%`;

          gsap.to(this.$refs['p-ftMv__bg'], {
            height: bgH,
            width: bgW,
            delay: 0.1,
            duration: 0.9,
            ease: Power2.easeInOut
          });

          gsap.fromTo(this.$refs['p-ftMv__info'], {
            opacity: 0
          }, {
            delay: 0.9,
            duration: 0.7,
            opacity: 1,
            ease: Power2.easeOut,
          });

          gsap.to(this.$refs['p-ftMv__bgImg'], {
            height: frameH,
            width: frameW,
            left: frameX,
            top: frameY,
            delay: 0.1,
            duration: 0.9,
            ease: Power2.easeInOut,
            onComplete: this.startComp
          });

          this.$nextTick(function() {
            this.renders.forEach((o) => {
              o.resize();
            });
          });
        },
        resize() {
          let imgW, imgH;
          const winW = this.getBodyWidth();
          const winH = window.innerHeight;
          this.windowHeight = winH;

          let adjust = {};
          if (window.innerWidth > breakpoint) {
            this.ispc = true;
            imgW = this.mvSize.pc.w;
            imgH = this.mvSize.pc.h;

            if (this.isStart) {
              if (window.innerWidth > 1366) {
                adjust = this.mvAdjust.pc;
              } else {
                adjust = {
                  w: (this.mvAdjust.pc.w / 1366) * window.innerWidth,
                  h: this.mvAdjust.pc.h
                };
              }
            } else {
              adjust = {h: 0, w: 0};
            }
          } else {
            this.ispc = false;
            //adjust = this.mvAdjust.sp;
            adjust = {
              h: (this.mvAdjust.sp.h / 750) * window.innerWidth,
              w: 0
            };
            imgW = this.mvSize.sp.w;
            imgH = this.mvSize.sp.h;
          }

          if (this.ispc || this.preWidth !== winW) {
            // ブラウザサイズにフィット
            const bgW = winW - adjust.w;
            const bgH = winH - adjust.h;
            const scale = Math.max(bgW / imgW, bgH / imgH);
            const frameW = imgW * scale;
            const frameH = imgH * scale;
            const frameX = (bgW - frameW) / 2;
            const frameY = (bgH - frameH) / 2;

            this.styleMv = `height:${winH}px; width:${winW}px`;

            gsap.set(this.$refs['p-ftMv__bg'], {
              height: bgH,
              width: bgW
            });

            gsap.set(this.$refs['p-ftMv__bgImg'], {
              height: frameH,
              width: frameW,
              left: frameX,
              top: frameY
            });
          }

          const sY = this.currentScrollY();
          this.$el.querySelectorAll('.js-scroll').forEach((el, index) => {
            const rect = el.getBoundingClientRect();
            this.elView[index] = {
              el: el,
              top: rect.top + sY,
              isShow: (this.elView[index]['isShow']) ? true : false
            }
          });

          this.preWidth = winW;

          if (this.isStart) {
            this.scroll();

            this.$nextTick(function() {
              this.renders.forEach((o) => {
                o.resize();
              });
            });
          }
        },
        scroll() {
          const sY = this.currentScrollY();

          if ((window.innerHeight * 0.3) < sY) {
            this.isScrollHide = true;
          } else {
            this.isScrollHide = false;
          }

          if (this.elView.length) {
            const tY = sY + (window.innerHeight * 0.8);
            for (let i in this.elView) {
              if (this.elView[i].isShow) continue;
              if (tY > this.elView[i].top) {
                this.elView[i].isShow = true;
                this.elShow.push(this.elView[i]);
                this.animation();
              }
            }
          }
        },
        animation() {
          requestAnimationFrame(this.show);
        },
        show() {
          this.elShow.forEach((o, i) => {
            gsap.fromTo(o.el.querySelector('.js-scroll__title'),{
              opacity: 0,
              y: 60,
              visibility: 'visible'
            },{
              duration: 0.7,
              opacity: 1,
              y: 0,
              ease: Power2.easeOut
            });

            if (o.el.querySelector('.p-ft__wrapFt__vCatch')) {
              gsap.fromTo(o.el.querySelector('.p-ft__wrapFt__vCatch'),{
                opacity: 0,
                y: 60,
                visibility: 'visible'
              },{
                duration: 0.7,
                opacity: 1,
                y: 0,
                ease: Power2.easeOut
              });
            }

            gsap.fromTo(o.el.querySelector('.js-scroll__v'),{
              opacity: 0,
              y: 100,
              visibility: 'visible'
            },{
              delay: 0.1,
              duration: 0.7,
              opacity: 1,
              y: 0,
              ease: Power2.easeOut
            });


          });

          this.elShow = [];
        },
        /*videoEvent(e) {
          if (e.type === 'canplay') {
            // 再生開始とする
          } else if (e.type === 'ended') {
            // 再生終了
          } else if (e.type === 'loadstart') {

          }
        },*/
        parallax() {
          this.renders.forEach((o) => {
            o.render();
          });

          gsap.set(this.$refs['p-ftMv__bg'], {y: this.currentScrollY() * 0.6});

          requestAnimationFrame(() => {
            this.parallax();
          });
        },
        scrollMv(e) {
          this.$_onAnchor(e);
        },
        getBodyWidth() {
          return document.body.clientWidth || window.innerWidth;
        },
        currentScrollY() {
          return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        }
      }
    });
  }
}
